// extracted by mini-css-extract-plugin
export default {"info":"style_info__I7Tvl","body":"style_body__tBhnn","lineInfo":"style_lineInfo__Xzoqp","margin":"style_margin__cRgmG"};